import { PM_PROVIDERS } from 'common/constants/constants';
import { FILTER_TYPES } from 'common/constants/filters';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import _ from 'lodash';

// Custom hook to create CFR MTTR configuration object from selected filters and incidents configuration object
export const useCreateConfigurationFromFilters = ({
  selectedFilters,
  incidentStrategy,
  incidentConfig,
  shouldAddIncidentToConfig
}) => {
  const pmProvider = usePmProvider();
  const isClubhouse = pmProvider === PM_PROVIDERS.CLUBHOUSE;

  const addIncidentsConfig = configuration => {
    const durationConfig = {
      incident_strategy_config: {
        strategy: incidentStrategy,
        config: incidentConfig
      }
    };
    return {
      ...configuration,
      ...(shouldAddIncidentToConfig ? { ...durationConfig } : {})
    };
  };

  /**
   * @param {object} filters
   * @returns {object} configuration
   * {
   *  issue_types: ['Bug', 'subtask'],
   *  labels: [{ name: 'A Team' }],
   *  fields: [{id: customfield_12345, value: ['High']}]
   * }
   */
  const createSingleFiltersConfigurationObject = filters => {
    const issueTypesNamesSelected = _.get(
      filters,
      FILTER_TYPES.ISSUE_TYPES,
      []
    ).map(({ title }) => (isClubhouse ? title?.toLowerCase() : title));
    const labelsSelected = _.get(filters, FILTER_TYPES.LABEL, []).map(
      ({ title }) => ({ name: title })
    );

    const customFilters = _.omit(filters, [
      FILTER_TYPES.ISSUE_TYPES,
      FILTER_TYPES.LABEL
    ]);
    const fieldsSelected = _.map(customFilters, (values, key) => {
      return {
        id: key,
        value: _.map(values, ({ title }) => title)
      };
    }).filter(({ value }) => !_.isEmpty(value));

    return {
      issue_types: issueTypesNamesSelected,
      labels: labelsSelected,
      fields: fieldsSelected
    };
  };

  const createConfigurationFromSelectedFilters = () => {
    const filteredSelectedFilters = selectedFilters.filter(entityType =>
      // filter out configurations with no values at all
      Object.values(entityType).some(values => values.length > 0)
    );
    const filtersToConfiguration = {
      or_filters: filteredSelectedFilters.map(filters =>
        createSingleFiltersConfigurationObject(filters)
      )
    };
    const configuration = addIncidentsConfig(filtersToConfiguration);
    return configuration;
  };

  return {
    createConfigurationFromSelectedFilters
  };
};
